<template>
  <div
    class="Fuell-Table Fuell-Table--cards"
    ref="table"
  >
    <div
      class="Fuell-Table--header"
      :style="tableGridTemplateStyle"
    >
      <template v-for="column in columns">
        <div
          v-if="column.visible"
          :key="column.key"
          @click="sortByField(column.key)"
          class="Fuell-Table--item"
          :class="{'Fuell-Table--sortable': column.sortable}"
        >
          <span v-if="hasHeader(column)">{{$t(column.name)}}</span>
          <span
            v-if="hasHeader(column)"
            class="sortable-handler"
            :class="getSortableClass(isSortedByField(column.key), sortDirection(column.key))"
          ></span>
        </div>
      </template>
    </div>
    <div class="Fuell-Table--content">
      <template v-if="!isLoadingCards">
        <cards-table-row
          v-for="card in cards"
          :columns="columns"
          :key="card.id"
          :card="card"
          @showCardDetailModal="showCardDetailModal"
        ></cards-table-row>
      </template>
      <div
        class="Fuell-Table--spinner"
        v-if="isLoadingCards || isLoadingNextPageCards"
      >
        <spinner></spinner>
      </div>
    </div>
  </div>
</template>

<script>
import CardsTableRow from './CardsTableRow'
import Spinner from '@/components/Commons/Spinner'
import _tableSortingHandler from '@/components/Commons/_mixins/_tableSortingHandler'
import _sortableTableMixin from '@/components/Commons/_mixins/_sortableTableMixin'
import _paginationHandlerMixin from '@/components/Commons/_mixins/_paginationHandlerMixin'

export default {
  name: 'CardsTable',
  components: { CardsTableRow, Spinner },
  data () {
    return {
      cardId: undefined
    }
  },
  props: {
    columns: {
      type: Array,
      required: true
    }
  },
  computed: {
    tableGridTemplateStyle () {
      let columns = this.columns.map(c => c.template)
      return {
        gridTemplateColumns: columns.join(' ')
      }
    },
    cards () {
      return this.$store.getters['CardsStore/cards'] || []
    },
    isLoadingCards () {
      return this.$store.getters['CardsStore/isLoadingCards']
    },
    isLoadingNextPageCards () {
      return this.$store.getters['CardsStore/isLoadingNextPageCards']
    },
    currentFilters () {
      return this.$store.getters['CardsStore/filters']
    },
    currentPage () {
      return this.$store.getters['CardsStore/currentPage']
    },
    lastPage () {
      return this.$store.getters['CardsStore/lastPage']
    }

  },
  mixins: [

    _paginationHandlerMixin,
    _sortableTableMixin,
    _tableSortingHandler

  ],
  methods: {
    hasHeader (column) {
      return !column.noHeader
    },
    showCardDetailModal (event) {
      this.$emit('showCardDetailModal', event)
    },
    async nextPage () {
      await this.$store.dispatch('CardsStore/nextCardsPage')
    },
    async sortByField (fieldName) {
      await this.$store.dispatch('CardsStore/sortCardsByField', { fieldName })
    }

  }
}
</script>
<style lang="scss" scoped>
.Fuell-Table {
  padding-bottom: 100px;
}

.Fuell-Table--header {
  grid-gap: 30px;
}
</style>
